import { useThemeContext } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import { getId } from './utils';
import { useDarkFromRoute } from '../../../utils/sitecoreContext';
import { variant1, variant2, variant3, variant4 } from './constants';
export var useConfiguration = function (variant) {
    var borders = useThemeContext().borders;
    var isDark = useDarkFromRoute();
    var t = useTranslation().t;
    var sliderIndicators = 'isRound';
    var accordionsIconColorOverride = 'primary';
    var accordionsLabelColor = isDark ? 'white' : 'black';
    var arrowIconSize = 'large';
    var borderColor = 'grey.2';
    var boxShadow = ['0px -2px 4px rgba(0, 0, 0, 0.1)', 'none', 'none'];
    var borderTop = borders[1];
    var ctaAriaLabel = function (trimName) { return t('Shared.TrimSpecifications.buildThisTrimAriaLabel', { trimName: trimName }); };
    var ctaForceRender = false;
    var ctaLabel = t('Shared.TrimSpecifications.buildThisTrimLabel');
    var ctaStyling = {};
    var hasBapURL = true;
    var priceStyles;
    var showMobilePagination;
    var showModelYear;
    var showSaveAsPDF;
    var suppressDiscount = true;
    var showPaymentDetails = false;
    var toolTipMarginLeft = 'xs';
    var badgePosition = '70px';
    var trimCardInviewStyles = {};
    var addInteriorColorUpCharge = false;
    var sellingPriceTooltipDiscalimerLabel = t('Shared.Common.sellingPriceTooltipLabel');
    var getItemId = getId;
    switch (variant) {
        // HONDA_SITE_NAME
        case variant1:
            showSaveAsPDF = true;
            addInteriorColorUpCharge = true;
            break;
        // ACURA_SITE_NAME
        case variant2:
            accordionsIconColorOverride = 'black';
            accordionsLabelColor = 'primary';
            showMobilePagination = false;
            addInteriorColorUpCharge = true;
            showSaveAsPDF = true;
            break;
        // PSP_SITE_NAME
        case variant3:
            arrowIconSize = 'default';
            borderColor = null;
            borderTop = null;
            boxShadow = 'none';
            ctaAriaLabel = function () { return t('Pages.Models.Exploration.viewModelDetailsButton'); };
            ctaForceRender = true;
            ctaLabel = t('Pages.Models.Exploration.viewModelDetailsButton');
            ctaStyling = { pt: 'xl' };
            hasBapURL = false;
            showMobilePagination = true;
            showModelYear = false;
            toolTipMarginLeft = 'xxs';
            suppressDiscount = false;
            priceStyles = {
                priceStyles: {
                    title: {
                        size: 'extraSmall',
                    },
                },
            };
            badgePosition = ['68px', '70px', '70px'];
            trimCardInviewStyles = { display: 'flex', flex: '1', justifyContent: 'center' };
            break;
        // PE_SITE_NAME
        case variant4:
            ctaAriaLabel = function () { return t('Shared.Common.learnMoreButton'); };
            ctaForceRender = true;
            ctaLabel = t('Shared.Common.learnMoreButton');
            hasBapURL = false;
            showMobilePagination = true;
            showSaveAsPDF = false;
            sellingPriceTooltipDiscalimerLabel = t('Shared.Common.sellingPriceTooltipText');
            break;
        default:
            break;
    }
    return {
        hasBapURL: hasBapURL,
        showMobilePagination: showMobilePagination,
        showModelYear: showModelYear,
        showSaveAsPDF: showSaveAsPDF,
        showPaymentDetails: showPaymentDetails,
        suppressDiscount: suppressDiscount,
        addInteriorColorUpCharge: addInteriorColorUpCharge,
        styles: {
            priceStyles: priceStyles,
            slider: {
                pagination: {
                    arrowIconSize: arrowIconSize,
                    sliderIndicators: sliderIndicators,
                    borderTop: borderTop,
                    borderColor: borderColor,
                    boxShadow: boxShadow,
                },
                tooltip: {
                    toolTipMarginLeft: toolTipMarginLeft,
                },
            },
            badgePosition: badgePosition,
        },
        cta: {
            label: ctaLabel,
            ariaLabel: ctaAriaLabel,
            styling: ctaStyling,
            forceRender: ctaForceRender,
        },
        accordion: {
            iconColorOverride: accordionsIconColorOverride,
            labelColor: accordionsLabelColor,
        },
        trimCardInviewStyles: trimCardInviewStyles,
        getItemId: getItemId,
        sellingPriceTooltipDiscalimerLabel: sellingPriceTooltipDiscalimerLabel,
    };
};
export default useConfiguration;
